import { isBrowser } from '../utils';
import type { PageContext } from '../types';
import { resolveNextRouteName } from './resolveNextRouteName';

let currentPage: PageContext = {};

export function getPageContext(): PageContext {
  if (!isBrowser()) return { ...currentPage };
  return {
    page_url: window.location.href,
    referrer_url: document.referrer || undefined,
    page_name: document.title || undefined,
    ...currentPage,
  };
}

export function setPageContext(patch: PageContext): void {
  currentPage = { ...currentPage, ...patch };
}

export function collectDefaultPage(): PageContext {
  if (!isBrowser()) return {};
  const pathname = window.location.pathname;
  return {
    page_url: window.location.href,
    referrer_url: document.referrer || '',
    page_name: document.title || '',
    page_id: pathname,
    route_name: resolveNextRouteName(pathname),
  };
}
